// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/*@font-face {
    font-family: 'Poppins';
    src: url('../assets/fonts/Poppins/Poppins-Regular.ttf') format(truetype);
    font-weight: 400;
    font-style: normal;
}*/
/* --------- Cores Principais
Essas cores compõem a identidade visual da empresa 
*/
/* --------- Gradação Primária
Utilização em fundos, campos de preenchimentos, botões
ou caixas de diálogo, contrastes para textos ou elementos 
gráficos.
*/
/* --------- Gradação Neutros
Gradação até 400 -> Utilização em fundos, campos 
de preenchimentos, botões ou caixas de diálogo.

Gradação depois de 400 -> Utilização em contrastes 
para textos ou elementos gráficos neutros.
*/
/* --------- Texto Padrão
Utilização em tipografia padrão para corpo de texto,
 títulos e afins*/
/* --------- Texto em Destaque
Utilização em tipografia em destaque como displays, 
links, breadcrumbs, botões, avisos, call to action 
e afins*/
/* --------- Mensagens do Sistema
Utilização em mensagens de informações relevantes 
do sistema*/
/* ---------- Margens
Elementos estáticos ou inativos*/
/* ---------- Highlight
Elementos ativos, hover ou seleção*/
/* --------- Cantos arredondados
Orientações para aplicação de arredondamento 
em elementos gráficos nas interfaces MicroUniverso 
*/
/* O padrão para arredondamento de cantos no MicroUniverso Design System segue a regra de múltiplos de 4px.

A escala tem por objetivo criar um balanço estético que contribui com a compreensão geral da interface. */
@media (min-width: 1024px) {
  .sG4COcM0AUX7k_3xPeHq {
    display: grid;
    grid_template_columns: repeat(12, 1fr);
    gap: 24px;
  }
}
@media (min-width: 768px) and (max-width: 1024px) {
  .sG4COcM0AUX7k_3xPeHq {
    display: grid;
    grid_template_columns: repeat(8, 1fr);
    gap: 16px;
  }
}
@media (max-width: 768px) {
  .sG4COcM0AUX7k_3xPeHq {
    display: grid;
    grid_template_columns: repeat(4, 1fr);
    gap: 8px;
  }
}

/*Quando for aplicar o grid, colocar o seguinte código na div desejada e
alterar o "ComponentModule" pelo nome do modulo do seu scss

<div className={ComponentModule.gridMU}>exemplo grid</div>
*/
/* --------- Sombras
 Orientações para aplicação de sombreamento em elementos gráficos
 nas interfaces MicroUniverso 
*/
/* As sombras ajudam na criação de hierarquia visual de informações e ênfase em elementos gráficos como imagens e caixas de diálogo */
/* --------- Display
Títulos com máximo destaque.*/
/* --------- Headings
Títulos padrão.*/
/* --------- Body
Corpo do texto.*/
/* --------- Pontuais
Pequenos textos para compor 
legendas, botões e afins.*/
.CwTcz5WZSep1qeDWMJI5 {
  cursor: pointer;
  font-size: 14px;
  font-weight: 700;
  line-height: 16px;
  letter-spacing: 1.5px;
  border-radius: 8px;
  font-family: "Poppins";
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0px 0px 6px 0px rgba(24, 24, 24, 0.2);
}

.KF2TEuIBceKvXXiI3yAn {
  background-color: #0172CB;
  color: #FDFDFD;
  border: 1px solid transparent;
}

.yk2ZGYslh1hXjM0Krkwm {
  background-color: #43A4D1;
  color: #FDFDFD;
  border: 1px solid transparent;
}

.eA4Okk8F93QlD0bAPvKn {
  border: 1px solid rgb(193, 193, 193);
}
.eA4Okk8F93QlD0bAPvKn:hover {
  border: 1px solid #43A4D1;
}

.YaZxZwvSHryPLzvBWgbQ {
  background-color: #646363;
  color: #FDFDFD;
  border: 1px solid transparent;
}

.scAcxFGbCbzZeiE9SGKE {
  border: 0;
  background-color: transparent;
  box-shadow: 0px 2px 16px 0px rgba(24, 24, 24, 0);
}

.rgFleCp0vB6GGi7uNj4_ {
  border: 1px solid transparent;
  background-color: transparent;
  color: #43A4D1;
}
.rgFleCp0vB6GGi7uNj4_:hover {
  border: 1px solid #43A4D1;
}

.JSCHlOMnFjRLW8KBvb5c {
  border: 1px solid #C1C1C1;
  background-color: #F3F3F3;
}
.JSCHlOMnFjRLW8KBvb5c:hover {
  border: 1px solid #43A4D1;
}

.iYmETeWS_ZGEM2wPiukx {
  color: #FDFDFD;
  border: 1px solid transparent;
  background-color: #E47777;
}

.M6TOVnmMOvki0qcHmH6n {
  border: 1px solid #C1C1C1;
  color: #C1C1C1;
  background-color: #F3F3F3;
}
.M6TOVnmMOvki0qcHmH6n:hover {
  border-color: #C1C1C1;
  cursor: default;
}

.a2WZiP1Kq5UsBTkfLqtj {
  cursor: default;
}
.a2WZiP1Kq5UsBTkfLqtj:hover {
  border-color: #C1C1C1;
  cursor: default;
}

.ginAe9cOa5G3jRmbmlBp {
  border-radius: 999px;
}

.C7OCxj__q8ptbOkyfTiQ {
  border-radius: 8px;
}

.DAUO64VbviAP3Sm1iv3p.R38pnRsllsyy7eeBHyLy {
  height: 48px;
  padding: 16px;
  gap: 12px;
}
.DAUO64VbviAP3Sm1iv3p.TnfxHsu8zqC4aTySNqee {
  height: 40px;
  padding: 12px 16px;
  gap: 12px;
}
.DAUO64VbviAP3Sm1iv3p.O6BhuPpipYOqsQZuvzqB {
  height: 32px;
  padding: 8px 16px;
  gap: 12px;
  font-size: 12px;
}
.DAUO64VbviAP3Sm1iv3p.USOFvcPK9StH3PinycKE {
  padding: 0;
  gap: 12px;
  font-size: 12px;
}

.zh5SEcVphDQbZcHH3Fj7.R38pnRsllsyy7eeBHyLy {
  padding: 16px;
  gap: 8px;
}
.zh5SEcVphDQbZcHH3Fj7.TnfxHsu8zqC4aTySNqee {
  padding: 8px;
  gap: 8px;
}
.zh5SEcVphDQbZcHH3Fj7.O6BhuPpipYOqsQZuvzqB {
  padding: 8px;
  gap: 8px;
}
.zh5SEcVphDQbZcHH3Fj7.USOFvcPK9StH3PinycKE {
  padding: 0px;
  gap: 8px;
}

.fDNap8lgeuSPsG0LKu7O.R38pnRsllsyy7eeBHyLy {
  height: 48px;
  width: 48px;
  padding: 8px;
  gap: 8px;
}
.fDNap8lgeuSPsG0LKu7O.TnfxHsu8zqC4aTySNqee {
  height: 40px;
  width: 40px;
  padding: 8px;
  gap: 8px;
}
.fDNap8lgeuSPsG0LKu7O.O6BhuPpipYOqsQZuvzqB {
  height: 32px;
  width: 32px;
  padding: 8px;
  gap: 8px;
}
.fDNap8lgeuSPsG0LKu7O.USOFvcPK9StH3PinycKE {
  height: 24px;
  padding: 0px;
  gap: 8px;
  border-radius: 8px;
}

.ZVcQUQJoyk9M4OG5LIrW {
  cursor: inherit;
  display: flex;
  align-items: center;
  gap: 8px;
}`, "",{"version":3,"sources":["webpack://./src/componentes/Botao/Botao.module.scss","webpack://./src/styles/_font.scss","webpack://./src/styles/_colors.scss","webpack://./src/styles/_border.scss","webpack://./src/styles/_borderRadius.scss","webpack://./src/styles/_grid.scss","webpack://./src/styles/_shadow.scss","webpack://./src/styles/_typography.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB;;;;;EAAA;ACAA;;CAAA;AASA;;;;CAAA;AAgBA;;;;;;CAAA;AAkBA;;iBAAA;AAMA;;;QAAA;AAUA;;WAAA;AC1DA;gCAAA;AASA;mCAAA;ACVA;;;CAAA;AAeA;;yGAAA;ACiDE;EADF;IArBE,aAAA;IACA,sCAAA;IACA,SAlBoB;ELuBpB;AACF;AKkBE;EALF;IAdE,aAAA;IACA,qCAAA;IACA,SAnBmB;ELwBnB;AACF;AKeE;EATF;IAPE,aAAA;IACA,qCAAA;IACA,QApBmB;ELyBnB;AACF;;AKaA;;;;CAAA;AC7EA;;;CAAA;AASA,qIAAA;ACTA;6BAAA;AAYA;gBAAA;AAiBA;gBAAA;AAiBA;;0BAAA;APtCA;EACI,eAAA;EACA,eOwCgB;EPvChB,gBOsCkB;EPrClB,iBOuCkB;EPtClB,qBOuCqB;EPtCrB,kBIRK;EJSL,sBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iDMdU;AN4Fd;;AA3EA;EACI,yBEHS;EFIT,cEQU;EFPV,6BAAA;AA8EJ;;AA3EA;EACI,yBEVS;EFWT,cEEU;EFDV,6BAAA;AA8EJ;;AA3EA;EACI,oCAAA;AA8EJ;AA7EI;EACI,yBAAA;AA+ER;;AA3EA;EACI,yBEJW;EFKX,cErCO;EFsCP,6BAAA;AA8EJ;;AA3EA;EACI,SAAA;EACA,6BAAA;EACA,gDAAA;AA8EJ;;AA3EA;EACI,6BAAA;EACA,6BAAA;EACA,cErCS;AFmHb;AA7EI;EACI,yBAAA;AA+ER;;AA3EA;EACI,yBAAA;EACA,yBE/BW;AF6Gf;AA7EI;EACI,yBAAA;AA+ER;;AA3EA;EACI,cEvCU;EFwCV,6BAAA;EACA,yBEDqB;AF+EzB;;AA3EA;EACI,yBAAA;EACA,cE1CW;EF2CX,yBE9CW;AF4Hf;AA7EI;EACI,qBE7CO;EF8CP,eAAA;AA+ER;;AA5EA;EACI,eAAA;AA+EJ;AA9EI;EACI,qBEpDO;EFqDP,eAAA;AAgFR;;AA5EA;EAAiB,oBAAA;AAgFjB;;AA/EA;EAAgB,kBIxFP;AJ2KT;;AAhFI;EAAQ,YAAA;EAAa,aAAA;EAAc,SAAA;AAsFvC;AArFI;EAAS,YAAA;EAAa,kBAAA;EAAmB,SAAA;AA0F7C;AAzFI;EAAQ,YAAA;EAAa,iBAAA;EAAkB,SAAA;EAAU,eO5CjC;AP2IpB;AA9FI;EAAS,UAAA;EAAW,SAAA;EAAU,eO7Cd;APgJpB;;AA/FI;EAAQ,aAAA;EAAc,QAAA;AAoG1B;AAnGI;EAAS,YAAA;EAAa,QAAA;AAuG1B;AAtGI;EAAQ,YAAA;EAAa,QAAA;AA0GzB;AAzGI;EAAS,YAAA;EAAa,QAAA;AA6G1B;;AAzGI;EAAQ,YAAA;EAAc,WAAA;EAAY,YAAA;EAAa,QAAA;AAgHnD;AA/GI;EAAS,YAAA;EAAa,WAAA;EAAY,YAAA;EAAa,QAAA;AAqHnD;AApHI;EAAQ,YAAA;EAAa,WAAA;EAAY,YAAA;EAAa,QAAA;AA0HlD;AAzHI;EAAS,YAAA;EAAa,YAAA;EAAa,QAAA;EAAU,kBI5GxC;AJ2OT;;AA5HA;EACI,eAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AA+HJ","sourcesContent":["@use '../../styles/border' as border;\r\n@use '../../styles/borderRadius' as borderRadius;\r\n@use '../../styles/colors' as colors;\r\n@use '../../styles/font' as font;\r\n@use '../../styles/grid' as grid;\r\n@use '../../styles/shadow' as shadow;\r\n@use '../../styles/typography' as typography;\r\n\r\n.MUbutton{\r\n    cursor: pointer;\r\n    font-size: typography.$botao-1-font-size;\r\n    font-weight: typography.$botao-1-font-weight;\r\n    line-height: typography.$botao-1-line-height;\r\n    letter-spacing: typography.$botao-1-letter-spacing;\r\n    border-radius: borderRadius.$raio-8;\r\n    font-family: 'Poppins';\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    box-shadow: shadow.$sombra-mu-1\r\n}\r\n\r\n.primaryDark{\r\n    background-color: colors.$azul-mu-600;\r\n    color: colors.$neutro-mu-50;\r\n    border: 1px solid transparent;\r\n}\r\n\r\n.primaryLight{\r\n    background-color: colors.$azul-mu-500;\r\n    color: colors.$neutro-mu-50;\r\n    border: 1px solid transparent;\r\n}\r\n\r\n.outlined{\r\n    border: 1px solid rgba(193, 193, 193, 1);\r\n    &:hover{\r\n        border: 1px solid colors.$destaque-azul-mu-500;\r\n    }\r\n}\r\n\r\n.gray{\r\n    background-color: colors.$neutro-mu-600;\r\n    color: colors.$branco-mu;\r\n    border: 1px solid transparent;\r\n}\r\n\r\n.ghost {\r\n    border: 0;\r\n    background-color: transparent;\r\n    box-shadow: 0px 2px 16px 0px rgba(24, 24, 24, 0);\r\n}\r\n\r\n.text{\r\n    border: 1px solid transparent;\r\n    background-color: transparent;\r\n    color: colors.$azul-mu-500;\r\n    &:hover{\r\n        border: 1px solid colors.$destaque-azul-mu-500;\r\n    }\r\n}\r\n\r\n.text2{\r\n    border: 1px solid colors.$neutro-mu-400;\r\n    background-color: colors.$neutro-mu-100;\r\n    &:hover{\r\n        border: 1px solid colors.$destaque-azul-mu-500;\r\n    }\r\n}\r\n\r\n.error{\r\n    color: colors.$neutro-mu-50;\r\n    border: 1px solid transparent;\r\n    background-color: colors.$status-vermelho-mu-fill;\r\n}\r\n\r\n.disabled{\r\n    border: 1px solid colors.$neutro-mu-400;\r\n    color: colors.$neutro-mu-400;\r\n    background-color: colors.$neutro-mu-100;\r\n    &:hover{\r\n        border-color: colors.$neutro-mu-400;\r\n        cursor: default;   \r\n    }\r\n}\r\n.naoClicavel {\r\n    cursor: default;\r\n    &:hover{\r\n        border-color: colors.$neutro-mu-400;\r\n        cursor: default;   \r\n    }\r\n}\r\n\r\n.rounded_variant{border-radius: 999px;}\r\n.square_variant{border-radius: borderRadius.$raio-8;}\r\n\r\n.tipoDefault {\r\n    &.large{height: 48px;padding: 16px;gap: 12px;}\r\n    &.medium{height: 40px;padding: 12px 16px;gap: 12px;}\r\n    &.small{height: 32px;padding: 8px 16px;gap: 12px;font-size: typography.$botao-2-font-size}\r\n    &.xsmall{padding:0; gap: 12px;font-size: typography.$botao-2-font-size}\r\n}\r\n\r\n.tipoIconRound {\r\n    &.large{padding: 16px;gap: 8px;}\r\n    &.medium{padding: 8px;gap: 8px;}\r\n    &.small{padding: 8px;gap: 8px;}\r\n    &.xsmall{padding: 0px;gap: 8px;}\r\n}\r\n\r\n.tipoIconSquare {\r\n    &.large{height: 48px; width: 48px;padding: 8px;gap: 8px;}\r\n    &.medium{height: 40px;width: 40px;padding: 8px;gap: 8px;}\r\n    &.small{height: 32px;width: 32px;padding: 8px;gap: 8px;}\r\n    &.xsmall{height: 24px;padding: 0px;gap: 8px; border-radius: borderRadius.$raio-8}\r\n}\r\n\r\n.children {\r\n    cursor: inherit;\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n}","/*@font-face {\r\n    font-family: 'Poppins';\r\n    src: url('../assets/fonts/Poppins/Poppins-Regular.ttf') format(truetype);\r\n    font-weight: 400;\r\n    font-style: normal;\r\n}*/\r\n@import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');","/* --------- Cores Principais\r\nEssas cores compõem a identidade visual da empresa \r\n*/\r\n$azul-mu:#43A4D1;\r\n$azul-escuro-mu:#002E51;\r\n$laranja-mu:#F4762A;\r\n$branco-mu:#FDFDFD;\r\n$cinza-mu:#646363;\r\n\r\n/* --------- Gradação Primária\r\nUtilização em fundos, campos de preenchimentos, botões\r\nou caixas de diálogo, contrastes para textos ou elementos \r\ngráficos.\r\n*/\r\n$azul-mu-50:#E8F4FA;\r\n$azul-mu-100:#D9EDF6;\r\n$azul-mu-200:#B4DBED;\r\n$azul-mu-300:#8EC8E3;\r\n$azul-mu-400:#69B6DA;\r\n$azul-mu-500:#43A4D1;\r\n$azul-mu-600:#0172CB;\r\n$azul-mu-700:#015BA2;\r\n$azul-mu-800:#01447A;\r\n$azul-mu-900:#002E51;\r\n\r\n/* --------- Gradação Neutros\r\nGradação até 400 -> Utilização em fundos, campos \r\nde preenchimentos, botões ou caixas de diálogo.\r\n\r\nGradação depois de 400 -> Utilização em contrastes \r\npara textos ou elementos gráficos neutros.\r\n*/\r\n$neutro-mu-50:#FDFDFD;\r\n$neutro-mu-100:#F3F3F3;\r\n$neutro-mu-200:#DADADA;\r\n$neutro-mu-300:#CDCDCD;\r\n$neutro-mu-400:#C1C1C1;\r\n$neutro-mu-500:#A2A1A1;\r\n$neutro-mu-600:#646363;\r\n$neutro-mu-700:#504F4F;\r\n$neutro-mu-800:#3C3B3B;\r\n$neutro-mu-900:#001729;\r\n\r\n/* --------- Texto Padrão\r\nUtilização em tipografia padrão para corpo de texto,\r\n títulos e afins*/\r\n$texto-cinza:#646363;\r\n$texto-preto:#001729;\r\n\r\n/* --------- Texto em Destaque\r\nUtilização em tipografia em destaque como displays, \r\nlinks, breadcrumbs, botões, avisos, call to action \r\ne afins*/\r\n$destaque-azul-mu-500:#43A4D1;\r\n$destaque-azul-mu-600:#0172CB;\r\n$destaque-azul-escuro-mu:#002E51;\r\n$destaque-laranja-mu:#F4762A;\r\n$destaque-branco-mu:#FDFDFD;\r\n\r\n/* --------- Mensagens do Sistema\r\nUtilização em mensagens de informações relevantes \r\ndo sistema*/\r\n$status-azul-mu:#0172CB;\r\n$status-azul-mu-fill:#69B6DA;\r\n$status-azul-mu-bg:#E8F4FA;\r\n$status-verde-mu:#119822;\r\n$status-verde-mu-fill:#70C17A;\r\n$status-verde-mu-bg:#E2F2E5;\r\n$status-laranja-mu:#F4762A;\r\n$status-laranja-mu-fill:#F8AD7F;\r\n$status-laranja-mu-bg:#FDE4D4;\r\n$status-vermelho-mu:#D21C1C;\r\n$status-vermelho-mu-fill:#E47777;\r\n$status-vermelho-mu-bg:#F8DBDB;\r\n$status-amarelo-mu:#EFCA08;\r\n$status-amarelo-mu-fill:#F6E483;\r\n$status-amarelo-mu-bg:#FDFAE9;\r\n","@use 'colors' as colors;\r\n/* ---------- Margens\r\nElementos estáticos ou inativos*/\r\n$margem-stroke-style:solid;\r\n$margem-border:1px;\r\n$margem-alignment:inside;\r\n$margem-color-1:#BAB8AC; \r\n$margem-color-2:#DDDBD6;\r\n$margem-color-3:#BAB8AC;\r\n\r\n/* ---------- Highlight\r\nElementos ativos, hover ou seleção*/\r\n$margem-color-ativo: colors.$laranja-mu; \r\n$margem-color-hover: colors.$azul-mu;\r\n$margem-color-selecao: colors.$azul-mu-600;\r\n","/* --------- Cantos arredondados\r\nOrientações para aplicação de arredondamento \r\nem elementos gráficos nas interfaces MicroUniverso \r\n*/\r\n\r\n$raio-4: 4px;\r\n$raio-8: 8px;\r\n$raio-12: 12px;\r\n$raio-16: 16px;\r\n$raio-20: 20px;\r\n$raio-24: 24px;\r\n$raio-32: 32px;\r\n$raio-48: 12px;\r\n$raio-999:999px;\r\n\r\n/* O padrão para arredondamento de cantos no MicroUniverso Design System segue a regra de múltiplos de 4px.\r\n\r\nA escala tem por objetivo criar um balanço estético que contribui com a compreensão geral da interface. */","//spacing\r\n\r\n$spacing-4 : 4px;\r\n$spacing-8 : 8px;\r\n$spacing-12 : 12px;\r\n$spacing-16 : 16px;\r\n$spacing-20 : 20px;\r\n$spacing-24 : 24px;\r\n$spacing-32 : 32px;\r\n$spacing-40: 40px;\r\n$spacing-48 : 48px;\r\n$spacing-56: 56px;\r\n$spacing-64 : 64px;\r\n$spacing-88 : 88px;\r\n$spacing-112 : 112px;\r\n$spacing-160 : 160px;\r\n$spacing-192 : 192px;\r\n$spacing-256 : 256px;\r\n$spacing-320 : 320px;\r\n$spacing-448: 448px;\r\n$spacing-512 : 512px;\r\n\r\n\r\n// Variáveis para grid desktop\r\n$grid_container_min_width_desktop: 1024px; // Defina o valor apropriado\r\n$grid_columns_desktop: 12;\r\n$grid_gutter_desktop: 24px;\r\n\r\n// Variáveis para grid tablet\r\n$grid_container_min_width_tablet: 768px;\r\n$grid_columns_tablet: 8;\r\n$grid_margin_tablet: 40px;\r\n$grid_gutter_tablet: 16px;\r\n\r\n// Variáveis para grid mobile\r\n$grid_container_min_width_mobile: 320px;\r\n$grid_columns_mobile: 4;\r\n$grid_margin_mobile: 20px;\r\n$grid_gutter_mobile: 8px;\r\n\r\n// Mixin para a grid _desktop\r\n@mixin make_grid_desktop($columns, $gutter_width) {\r\n  display: grid;\r\n  grid_template_columns: repeat($columns, 1fr);\r\n  gap: $gutter_width;\r\n}\r\n\r\n// Mixin para a grid _tablet\r\n@mixin make_grid_tablet($columns, $gutter_width) {\r\n  display: grid;\r\n  grid_template_columns: repeat($columns, 1fr);\r\n  gap: $gutter_width;\r\n}\r\n\r\n// Mixin para a grid _mobile\r\n@mixin make_grid_mobile($columns, $gutter_width) {\r\n  display: grid;\r\n  grid_template_columns: repeat($columns, 1fr);\r\n  gap: $gutter_width;\r\n}\r\n\r\n// Aplicando as grids\r\n\r\n.gridMU {\r\n  @media (min-width: $grid_container_min_width_desktop) {\r\n    @include make_grid_desktop($grid_columns_desktop, $grid_gutter_desktop);\r\n  }\r\n\r\n  @media (min-width: $grid_container_min_width_tablet) and (max-width: $grid_container_min_width_desktop) {\r\n    @include make_grid_tablet($grid_columns_tablet, $grid_gutter_tablet);\r\n  }\r\n\r\n  @media (max-width: $grid_container_min_width_tablet) {\r\n    @include make_grid_mobile($grid_columns_mobile, $grid_gutter_mobile);\r\n  }\r\n}\r\n\r\n/*Quando for aplicar o grid, colocar o seguinte código na div desejada e\r\nalterar o \"ComponentModule\" pelo nome do modulo do seu scss\r\n\r\n<div className={ComponentModule.gridMU}>exemplo grid</div>\r\n*/","/* --------- Sombras\r\n Orientações para aplicação de sombreamento em elementos gráficos\r\n nas interfaces MicroUniverso \r\n*/\r\n\r\n$sombra-mu-1: 0px 0px 6px 0px rgba(24, 24, 24, 0.20);\r\n$sombra-mu-2: 0px 2px 12px 0px rgba(24, 24, 24, 0.1);\r\n$sombra-mu-3: 0px 2px 16px 0px rgba(24, 24, 24, 0.05);\r\n\r\n/* As sombras ajudam na criação de hierarquia visual de informações e ênfase em elementos gráficos como imagens e caixas de diálogo */","/* --------- Display\r\nTítulos com máximo destaque.*/\r\n$display-1-weight: 700;\r\n$display-1-size: 80px;\r\n$display-1-line-height: 88px;\r\n$display-1-letter-spacing: -2px;\r\n\r\n$display-2-weight: 700;\r\n$display-2-size: 48px;\r\n$display-2-line-height: 56px;\r\n$display-2-letter-spacing: -1px;\r\n\r\n/* --------- Headings\r\nTítulos padrão.*/\r\n$heading-1-weight: 700;\r\n$heading-1-size: 32px;\r\n$heading-1-line-height: 40px;\r\n$heading-1-letter-spacing: -0.5px;\r\n\r\n$heading-2-weight: 700;\r\n$heading-2-size: 24px;\r\n$heading-2-line-height: 32px;\r\n$heading-2-letter-spacing: -0.25px;\r\n\r\n$heading-3-weight: 700;\r\n$heading-3-size: 18px;\r\n$heading-3-line-height: 26px;\r\n$heading-3-letter-spacing: -0.25px;\r\n\r\n/* --------- Body\r\nCorpo do texto.*/\r\n$body-1-weight: 500;\r\n$body-1-weight-bold: 700;\r\n$body-1-size: 16px;\r\n$body-1-line-height: 24px;\r\n\r\n$body-2-weight: 500;\r\n$body-2-weight-bold: 700;\r\n$body-2-size: 14px;\r\n$body-2-line-height: 20px;\r\n\r\n$body-3-weight: 400;\r\n$body-3-weight-bold: 700;\r\n$body-3-size: 12px;\r\n$body-3-line-height: 18px;\r\n\r\n/* --------- Pontuais\r\nPequenos textos para compor \r\nlegendas, botões e afins.*/\r\n$botao-1-font-weight: 700;\r\n$botao-1-font-size: 14px;\r\n$botao-1-line-height: 16px;\r\n$botao-1-letter-spacing: 1.5px;\r\n\r\n$botao-2-font-weight: 700;\r\n$botao-2-font-size: 12px;\r\n$botao-2-line-height: 16px;\r\n$botao-2-letter-spacing: 1px;\r\n\r\n$label-1-font-weight: 700;\r\n$label-1-font-size: 14px;\r\n$label-1-line-height: 16px;\r\n$label-1-letter-spacing: 1px;\r\n\r\n$label-2-font-weight: 700;\r\n$label-2-font-size: 12px;\r\n$label-2-line-height: 16px;\r\n$label-2-letter-spacing: 1px;\r\n\r\n$label-3-font-weight: 700;\r\n$label-3-font-size: 10px;\r\n$label-3-line-height: 14px;\r\n$label-3-letter-spacing: 0.25px;\r\n\r\n$caption-font-weight: 400;\r\n$caption-font-weight-bold: 700;\r\n$caption-font-size: 12px;\r\n$caption-line-height: 20px;\r\n$caption-letter-spacing: 0.25px;\r\n\r\n$breadcrumb-font-style: italic;\r\n$breadcrumb-font-decoration: underline;\r\n$breadcrumb-font-weight: 400;\r\n$breadcrumb-font-size: 10px;\r\n$breadcrumb-line-height: 14px;\r\n$breadcrumb-letter-spacing: 0.25px;\r\n\r\n$overline-font-weight: 400;\r\n$overline-font-size: 10px;\r\n$overline-line-height: 14px;\r\n$overline-letter-spacing: 1.5px;"],"sourceRoot":""}]);
// Exports
export var gridMU = `sG4COcM0AUX7k_3xPeHq`;
export var MUbutton = `CwTcz5WZSep1qeDWMJI5`;
export var primaryDark = `KF2TEuIBceKvXXiI3yAn`;
export var primaryLight = `yk2ZGYslh1hXjM0Krkwm`;
export var outlined = `eA4Okk8F93QlD0bAPvKn`;
export var gray = `YaZxZwvSHryPLzvBWgbQ`;
export var ghost = `scAcxFGbCbzZeiE9SGKE`;
export var text = `rgFleCp0vB6GGi7uNj4_`;
export var text2 = `JSCHlOMnFjRLW8KBvb5c`;
export var error = `iYmETeWS_ZGEM2wPiukx`;
export var disabled = `M6TOVnmMOvki0qcHmH6n`;
export var naoClicavel = `a2WZiP1Kq5UsBTkfLqtj`;
export var rounded_variant = `ginAe9cOa5G3jRmbmlBp`;
export var square_variant = `C7OCxj__q8ptbOkyfTiQ`;
export var tipoDefault = `DAUO64VbviAP3Sm1iv3p`;
export var large = `R38pnRsllsyy7eeBHyLy`;
export var medium = `TnfxHsu8zqC4aTySNqee`;
export var small = `O6BhuPpipYOqsQZuvzqB`;
export var xsmall = `USOFvcPK9StH3PinycKE`;
export var tipoIconRound = `zh5SEcVphDQbZcHH3Fj7`;
export var tipoIconSquare = `fDNap8lgeuSPsG0LKu7O`;
export var children = `ZVcQUQJoyk9M4OG5LIrW`;
export default ___CSS_LOADER_EXPORT___;
